export function getSharedWorkoutExerciseClass({ readOnly, workoutStatus, status }) {
  if (!readOnly || status === 'removed') return '';
  const stateClass = workoutStatus === 'complete'
    ? 'shared-read-only-complete'
    : 'shared-read-only-vignette';
  return `shared-read-only ${stateClass}`;
}

export function shouldShowSharedWorkoutCoach({ readOnly }) {
  return !readOnly;
}
